import type { NextPage, GetStaticProps } from 'next';
import type { PageProps, QueryData } from '@/types/index';
import DefaultErrorPage from 'next/error';
import { useIsPreviewing } from '@builder.io/react';
import { restRequest } from '@/utils/restRequest';
import PageHead from '@/components/Head';
import LegalPage from '@/components/LegalPage';
import { domain } from '@/constants/config';

// set revalidate from env. This determines how long the pages will cache and
// therefore how long changes will take to appear
const revalidate = process.env.NEXT_PUBLIC_ENVIRONMENT === 'production' ? 60 : 1;
export const getStaticProps: GetStaticProps = async () => {
  /**
   * Calls for privacy policy data
   *
   * @note Using aliases to match data definition
   *
   */

  // Need to use different privacy policy for SMS on totalinjuryhelp.com
  const withSMS = domain === 'a3b98c26514c47659320d31f5308af20';
  const legalId = withSMS ? 'ee462a62f3cf4efeabbef53568355f60' : 'd93b1b88305447eea36a3da94adb5de4';
  const legalDataArr = await restRequest<QueryData<'page'>[]>('legal', `id=${legalId}`);
  const legalData = legalDataArr?.length && legalDataArr.length > 0 ? legalDataArr[0] : null;
  return {
    props: {
      content: {
        legalData
      }
    },
    revalidate
  };
};
export const Page: NextPage<PageProps> = ({
  content
}) => {
  const isPreviewing = useIsPreviewing();
  if (!content.legalData && !isPreviewing) {
    return <DefaultErrorPage statusCode={404} />;
  }
  const legalRichText = content.legalData?.data.text || null;
  return <>
			<PageHead path="/privacy-policy" title={'Total Injury Help | Privacy Policy'} description="" shareImage="/TotalInjuryHelp_logo.webp" data-sentry-element="PageHead" data-sentry-source-file="privacy-policy.tsx" />

			{legalRichText && <LegalPage text={legalRichText} />}
		</>;
};
export default Page;